import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PersonaType } from '@constants/global.enum';
import {
  Candidate,
  CandidatesResponse,
} from '../add-candidate/add-candidate.model';
import { AddCandidateService } from '../add-candidate/add-candidate.service';
import { GlobalErrorService } from '@services/global-error.service';
import { ToasterService } from '@services/toaster.service';
@Component({
  selector: 'app-delete-candidate',
  templateUrl: './delete-candidate.component.html',
  styleUrl: './delete-candidate.component.scss',
})
export class DeleteCandidateComponent {
  @Input() candidateId: string = '';
  @Input() fieldsVisibility: string = '';
  @Input() candidateName: string = '';
  @Input() delete: boolean = false;
  @Output() updateState = new EventEmitter<boolean>();
  @Output() candidateDeleted = new EventEmitter<boolean>();

  popopOpened: boolean = false;
  personaType = PersonaType;
  candidatesDetail: Candidate | null = null;
  candidateData: Candidate | null = null;

  constructor(
    private errorHandler: GlobalErrorService,
    public addCandidateService: AddCandidateService,
    private toasterService: ToasterService
  ) {}

  ngOnChanges() {
    this.popopOpened = this.delete;
    if (this.popopOpened === true) {
    this.fetchCandidates();
      
    }
  }
  resetActions(event: boolean) {
    this.delete = false;
    this.updateState.emit(true);
  }
  updateActions(isDelete: boolean) {
    if (isDelete) {
      this.delete = false;
    }
    this.updateState.emit(true);
  }
  fetchCandidates() {
    this.addCandidateService.getCandidateInfo(this.candidateId).subscribe(
      (res: CandidatesResponse) => {
        this.candidatesDetail = res.data;
      },
      (error) => {
        this.errorHandler.logComponentError(error);
      }
    );
  }
  deleteProfile(Status: string) {
    if (this.candidatesDetail) {
      const updatedCandidate = this.getUpdatedCandidate(Status);
      this.updateCandidateInfo(updatedCandidate);
    }
  }
  getUpdatedCandidate(Status: string): Candidate {
    return {
      candidateId: this.candidatesDetail!.candidateId,
      candidateName: this.candidatesDetail!.candidateName,
      emailId: this.candidatesDetail!.emailId,
      location: this.candidatesDetail!.location,
      earliestAvailability: this.candidatesDetail!.earliestAvailability,
      resumePath: this.candidatesDetail!.resumePath,
      additionalDocumentsPath: this.candidatesDetail!.additionalDocumentsPath,
      url: this.candidatesDetail!.url,
      hiringRequestId: this.candidatesDetail!.hiringRequestId,
      yearsOfExperience: this.candidatesDetail!.yearsOfExperience,
      yearsOfRelevantExperience:
        this.candidatesDetail!.yearsOfRelevantExperience,
      contactNumber: this.candidatesDetail!.contactNumber,
      status: Status,
      receivedOn: this.candidatesDetail!.receivedOn,
      position: this.candidatesDetail!.position,
      hiringManager: this.candidatesDetail!.hiringManager,
      jobTitle: this.candidatesDetail!.jobTitle,
      candidateSkills: this.candidatesDetail!.candidateSkills,
      createdBy: this.candidatesDetail!.createdBy,
      updatedBy: this.candidatesDetail!.updatedBy,
      vendorId: this.candidatesDetail!.vendorId,
    };
  }
  updateCandidateInfo(getCandidateData: Candidate) {
    this.addCandidateService.updateCandidateInfo(getCandidateData).subscribe(
      (res) => {
        let successMessage = 'Candidate Information Got Deleted successfully!';
        this.toasterService.showSuccess(successMessage, 'Success');
        this.popopOpened = false;
        this.candidateDeleted.emit(true);
      },
      (error) => {
        this.toasterService.showError(error.error.message, 'Error');
      }
    );
  }
}
